import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import {Events} from '../../services/events/events.service';
import {NavigationExtras, Router} from '@angular/router';
import {IonButton, IonCol, IonRow} from "@ionic/angular";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-announce',
  templateUrl: './announce.component.html',
  styleUrls: ['./announce.component.scss'],
  standalone: true,
  imports: [
    IonRow,
    IonCol,
    IonButton
  ]
})
export class AnnounceComponent {
  @Input() pageName: string;
  @Output() closed = new EventEmitter();
  closeAvailable: boolean = false;
  buttonAvailable: boolean = false;
  buttonString: string = '';
  buttonTab: number = 0;
  announceTitle: string = '';
  showDialog: boolean = false;
  announceContent: string = '';
  buttonPage:  string = '';
  gameId: number;
  gamesLive: number;
  constructor(
    public events: Events,
    private router: Router
  ) {
    events.subscribe('announce:changed', (announce) => {
      console.log('announce', announce);
      // console.log('this.router.url', this.router.url);
      console.log('this.router.url.split(\'?\')[0]', this.router.url.split('?')[0]);
      console.log('this.pageName', this.pageName);

      console.log('announce:changed')
      this.buttonAvailable = announce.button;
      this.closeAvailable = announce.close;
      if (this.buttonAvailable) {
        this.buttonString = announce.buttonString;
      } else {
        this.buttonString = '';
      }
      this.announceTitle = announce.title;
      this.announceContent = announce.content;
      this.buttonPage = announce.buttonPage;
      this.buttonTab = announce.buttonTab;
      this.gameId = announce.gameId;
      this.gamesLive = announce.gamesLive;
      // console.log("dfad1 game: "+this.gameId);
      this.showDialog = true;
    });
  }


  closeDialog(){
    this.resetAnnounce();
  }

  gotoPage(){
    this.resetAnnounce();
    // h1 if page is  LiveCardPage(i.e. the game) pass game ID


    const navigationExtras: NavigationExtras = {queryParams: {gameId: this.gameId}};

    const liveGamesArr = [
      '/tabs/mycards/football',
      '/tabs/mycards/bingoals',
      '/tabs/mycards/livecardf1'
    ]
    if(!liveGamesArr.includes(this.buttonPage) && this.gamesLive > 1){
      this.router.navigate([this.buttonPage]);
      return;
    }
    // console.log('navigationExtras', navigationExtras)

    this.router.navigate([this.buttonPage], navigationExtras);
  }

  resetAnnounce(){
    this.showDialog = false;
    this.closed.emit('dialog closed');
  }

}
